"use strict";var ComponentDef = require("../../../runtime/components/ComponentDef");

module.exports = function beginComponent(
componentsContext,
component,
key,
ownerComponentDef)
{
  var componentId = component.id;
  var componentDef = componentsContext.o_ = new ComponentDef(
    component,
    componentId,
    componentsContext
  );
  componentsContext.p_.q_[
  componentId] =
  true;
  componentsContext.b_.push(componentDef);

  var out = componentsContext.r_;
  out.bc(component, key, ownerComponentDef && ownerComponentDef.s_);
  return componentDef;
};